export const APP_URL = '';
export const APP_TITLE = 'My QR code';
export const MATOMO_URL = 'stats.outbook.es';
export const MATOMO_SITE_ID = '3';
export const MATOMO_STATUS = 'active';
